import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'
import { DdcProfilePicOnlyComponent } from '../ddc-profile-pic-only/ddc-profile-pic-only.component'

@Component({
  selector: 'ddc-search-result-user',
  templateUrl: './ddc-search-result-user.component.html',
  styleUrl: './ddc-search-result-user.component.scss',
  imports: [
    CommonModule,
    AngularMaterialsModules,
    DdcCountryFlagComponent,
    DdcProfilePicOnlyComponent,
  ],
})
export class DdcSearchResultUserComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Input() _DefaultProfilePic: string =
    'https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg'
  @Output() userClick = new EventEmitter<DataSearchResult>()

  onUserClick(): void {
    this.userClick.emit(this.result)
  }
}
